import type { ReactNode } from "react";

interface CollapsibleSectionProps {
    title: string;
    isOpen?: boolean;
    onToggle?: () => void;
    children: ReactNode;
}

export function CollapsibleSection({ title, isOpen, onToggle, children }: CollapsibleSectionProps) {
    return (
        <div className={`collapse collapse-arrow bg-base-100/50 border border-base-content/5 rounded-xl ${isOpen ? "flex-1 min-h-0 overflow-hidden" : "flex-none"}`}>
            <input
                type="checkbox"
                className="peer"
                checked={isOpen}
                onChange={onToggle}
            />
            <div className="collapse-title text-xs opacity-50 uppercase tracking-widest font-bold min-h-0 py-3">
                {title}
            </div>
            <div className="collapse-content px-3 pb-3 min-h-0 overflow-y-auto">
                {children}
            </div>
        </div>
    );
}
